import InterviewHead from 'components/Interview/Head';
import { FC, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReviewPageContext } from '.';

const Head: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  const menteeName: string = useMemo(() => {
    if (
      interview?.mentorship?.mentee?.firstName &&
      interview.mentorship.mentee.lastName
    ) {
      return `${interview.mentorship.mentee.firstName} ${interview.mentorship.mentee.lastName}`;
    }
    return 'Entretien';
  }, [interview]);

  const [searchParams] = useSearchParams();

  return (
    <InterviewHead
      backTo={
        searchParams.get('from') || '/mentor/mentorship/management/interviews'
      }
      interview={interview}
      title={menteeName}
      variant="mentor"
    />
  );
};

export default Head;
